import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FavoritesPanel = ({ favorites, onRemoveFavorite, onViewProblem, isOpen, onToggle }) => {
  if (!isOpen) {
    return (
      <div className="fixed right-4 top-24 z-40">
        <Button
          variant="outline"
          size="sm"
          onClick={onToggle}
          iconName="Heart"
          iconPosition="left"
          className="shadow-elevated bg-card"
        >
          Favorites ({favorites?.length})
        </Button>
      </div>
    );
  }

  return (
    <div className="fixed right-4 top-24 z-40 w-80 bg-card border border-border rounded-lg shadow-elevated max-h-96 overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Heart" size={20} className="text-error" />
          <h3 className="font-medium text-foreground">Favorites</h3>
          <span className="bg-muted text-muted-foreground text-xs px-2 py-1 rounded-full">
            {favorites?.length}
          </span>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggle}
        >
          <Icon name="X" size={16} />
        </Button>
      </div>
      {/* Content */}
      <div className="overflow-y-auto max-h-80">
        {favorites?.length === 0 ? (
          <div className="p-6 text-center">
            <Icon name="Heart" size={32} className="text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground text-sm">No favorites yet</p>
            <p className="text-muted-foreground text-xs mt-1">
              Click the heart icon on problems to save them here
            </p>
          </div>
        ) : (
          <div className="p-2">
            {favorites?.map((problem) => (
              <div key={problem?.id} className="p-3 border border-border rounded-lg mb-2 hover:bg-muted/30 transition-micro">
                <div className="flex items-start justify-between mb-2">
                  <h4 className="font-medium text-foreground text-sm line-clamp-2">
                    {problem?.title}
                  </h4>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onRemoveFavorite(problem?.id)}
                    className="h-6 w-6 text-error hover:bg-error/10"
                  >
                    <Icon name="X" size={12} />
                  </Button>
                </div>
                <p className="text-muted-foreground text-xs mb-2">{problem?.cityName}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-muted-foreground">
                    {problem?.complexity} • {problem?.teamSize} members
                  </span>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onViewProblem(problem?.id)}
                    className="h-6 text-xs"
                  >
                    View
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {favorites?.length > 0 && (
        <div className="p-4 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Download"
            iconPosition="left"
          >
            Export Favorites
          </Button>
        </div>
      )}
    </div>
  );
};

export default FavoritesPanel;